// extracted by mini-css-extract-plugin
export var externalLink = "_cq-0";
export var internalLinkLabel = "_cq-1";